import { useEffect, useRef, useState } from "react";
import { Play, X } from "lucide-react";
import { streamUrl } from "@/lib/portal";

const VideoPlayer = ({ video, onClose }) => {
  const videoRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  const preventContext = (e) => {
    e.preventDefault();
    return false;
  };

  return (
    <div
      data-testid="video-player-modal"
      className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4 sm:p-8 animate-fadeIn"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div
        ref={containerRef}
        className="w-full max-w-5xl bg-[#0a0a0a] border border-white/10 shadow-2xl flex flex-col"
        onContextMenu={preventContext}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
          <div className="min-w-0">
            <p className="text-[10px] uppercase tracking-[0.25em] text-[#8B0000] font-semibold mb-1 truncate">
              {video.category}
            </p>
            <h3 className="font-display text-xl sm:text-2xl text-white leading-snug truncate">
              {video.title}
            </h3>
          </div>
          <button
            data-testid="video-close-button"
            onClick={onClose}
            className="w-10 h-10 flex items-center justify-center text-white/70 hover:text-white hover:bg-white/10 transition-colors flex-shrink-0"
            aria-label="Close video"
          >
            <X size={22} />
          </button>
        </div>

        <div className="relative bg-black select-none">
          <video
            ref={videoRef}
            data-testid="video-element"
            src={streamUrl(video.id)}
            controls
            controlsList="nodownload noremoteplayback noplaybackrate"
            disablePictureInPicture
            autoPlay
            playsInline
            onContextMenu={preventContext}
            className="w-full aspect-video bg-black"
          >
            Your browser does not support the video element.
          </video>
          {/* Anti right-click overlay (does NOT block controls because we use pointer-events: none) */}
          <div
            className="pointer-events-none absolute inset-0"
            onContextMenu={preventContext}
          />
        </div>

        {video.description && (
          <div className="px-6 py-5 border-t border-white/10 max-h-40 overflow-y-auto">
            <p className="text-sm text-white/80 leading-relaxed">
              {video.description}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoPlayer;
